<template>
    <div id="message-detail-dialog" class="modal" tabindex="-1" role="dialog" v-bind:class="{ 'remove-right-padding': isFullWidthMobile }">
        <div v-bind:class="dialogWidthCss" class="message-detail-dialog-print modal-dialog modal-dialog-scrollable" role="document">
            <div class="modal-content">
                <div class="modal-header pb-1" v-if="mode !='SentConfirmation'">
                    <div class="container col-12 pl-0 pl-lg-2 pr-0 pr-lg-2">
                        <div class="row">
                            <div class="col"></div>
                            <div class="col-auto d-print-none">
                                <button type="button" class="close text-white btn-circle close-filter-dialog-button close-dialog-icon c-pointer m-0 p-0" data-dismiss="modal" aria-label="Close message">
                                    <span aria-hidden="true">&times;</span>
                                </button>
                            </div>
                        </div>
                    </div>
                </div>

                <div class="modal-body pt-1">
                    <div v-cloak class="container-fluid col-12 pl-lg-2 pr-lg-2">
                        <div class="row mb-3" v-if="mode !='SentConfirmation'">
                            <div class="col">
                                <h1 v-if="detailMessageChain" class="modal-title font-weight-bold detail-message-subject" data-ui="detail-message-subject">
                                    {{detailMessageChain[0].subject}}
                                </h1>
                            </div>
                        </div>

                        <div id="send-message-confirmation" v-if="mode =='SentConfirmation'">
                            <success-component :header-text="cmsComposeContentBlocks.mainPageSuccessScreenHeader"
                                               :sub-header-text="cmsComposeContentBlocks.mainPageSuccessScreenSubHeader"
                                               :button-text="cmsComposeContentBlocks.mainPageSuccessScreenOkButton">
                            </success-component>
                        </div>

                        <div v-if="mode !='SentConfirmation'">

                            <div v-if="mode =='Reply' && detailMessageChain" class="table-body-details-container">
                                <div class="col-12 mt-2">
                                    <replymessage-component :to-address="detailMessageChain[0].fromId"
                                                            :subject-to-use="detailMessageChain[0].subject"
                                                            :reply-to-message-id="detailMessageChain[0].msgId"
                                                            :attachment-group-id="attachmentGroupId"
                                                            :cms-compose-content-blocks="cmsComposeContentBlocks"
                                                            :disable-uploads="disableUploads"
                                                            @messagesent="onMessageSent"
                                                            @cancel="mode = 'Detail'">
                                    </replymessage-component>
                                </div>
                            </div>

                            <div v-for="responseMessageObject in detailMessageChain">
                                <div class="table-body-details-container p-4" data-ui="detail-message-chain-container" :data-ui-id="responseMessageObject.msgId">

                                    <div class="row">
                                        <div class="col-md-6 col-sm-12 text-capitalize col-text" data-ui="detail-message-from">
                                            <div class="appt-location-type"><strong>{{cmsContentBlocks.messageTableHeaderFrom}}:&nbsp;</strong>{{responseMessageObject.fromName}}</div>
                                        </div>

                                        <div class="col-md-6 col-sm-12 text-md-right text-sm-left" data-ui="detail-message-created-date">
                                            <strong>{{responseMessageObject.createdDate | formatToShortDate}} at {{responseMessageObject.createdDate | formatTime}} </strong>
                                        </div>
                                    </div>

                                    <div class="row my-2">
                                        <div class="col-md-6 col-sm-12 text-capitalize col-text" data-ui="detail-message-to">
                                            <div class="appt-location-type"><strong>{{cmsContentBlocks.messageTableHeaderTo}}:&nbsp;</strong>{{responseMessageObject.toName}}</div>
                                        </div>
                                    </div>

                                    <div class="row my-3" data-ui="detail-message-msg-body">
                                        <div class="col col-sm-12 col-text" v-html="responseMessageObject.msgBody"></div>
                                    </div>

                                    <div v-if="responseMessageObject.attachmentDetails && responseMessageObject.attachmentDetails.length > 0">

                                        <div v-for="attachment in responseMessageObject.attachmentDetails" class="row mt-1 mb-1">
                                            <div class="col">
                                                <i class="fas fa-fw fa-paperclip mr-2" aria-label="Attachment" v-bind:class="{ 'text-portal-primary-blue': !responseMessageObject.attachmentExpired }"></i><a target="_blank" :disabled="responseMessageObject.attachmentExpired" :href="buildAttachmentDownload(responseMessageObject,attachment)">{{attachment.name}}</a>
                                            </div>
                                        </div>

                                        <div class="row fs-13">
                                            <div class="col">
                                                {{cmsContentBlocks.documentDownloadPeriod}}
                                            </div>
                                        </div>
                                    </div>

                                </div>
                            </div>

                        </div>

                        <div v-if="showReplyButton && isNoReplyMessage" class="row mt-3">
                            <div class="col text-danger fs-15">
                                {{cmsContentBlocks.DoNotReplyMessage}}
                            </div>
                        </div>

                        <div v-if="showReplyButton && mailboxIsNoLongerActive" class="row mt-3">
                            <div class="col text-danger fs-15">
                                {{cmsContentBlocks.mailboxNotActive}}
                            </div>
                        </div>

                    </div>

                </div>

                <div class="modal-footer pt-2 pb-2 bg-portal-secondary-cream d-print-none">
                    <div class="container-fluid pl-0 pl-lg-2 pr-0 pr-lg-2">
                        <div class="row align-items-center" v-show="mode =='Detail'">
                            <div v-show="showDeleteButton" class="col">
                                <button @click="deleteMessage" type="button" class="btn btn-outline-danger" data-ui="detail-message-delete-button">
                                    <i class="far fa-trash-alt icon-button-w-text"></i>
                                    {{cmsContentBlocks.messageDetailDialogDeleteText}}
                                </button>
                            </div>
                            <!-- <div v-show="showReplyButton && !isNoReplyMessage && !mailboxIsNoLongerActive" class="col-auto text-md-right text-sm-left">
                                <button @click="setReplyMode" type="button" class="btn btn-primary" data-ui="detail-message-reply-button">
                                    <i class="far fa-reply icon-button-w-text" aria-label="Replay To Message"></i>{{cmsContentBlocks.messageDetailDialogReplyText}}
                                </button>
                            </div> -->
                            <div v-show="showRestoreButton" class="col-auto text-md-right text-sm-left">
                                <button @click="restoreMessage" type="button" class="btn btn-primary" data-ui="detail-message-restore-button">
                                    <i class="far fa-reply icon-button-w-text" aria-label="Restore Message"></i>{{cmsContentBlocks.messageDetailDialogRestoreText}}
                                </button>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>

</template>

<script>

    import formattingDirective from '@SharedVueComponents/formatting/formattingdirective';
    import { MessageHttpSvc } from '@SharedHttpServices/message.httpservice';
    import replyMessage from './reply.message.vue';
    import successComponent from '@PortalVueComponents/Success/success.vue';

    export default {
        name: 'message-detail-dialog',
        props: {
            //email chain of messages
            detailMessageChain: { type: Array, default: [] },

            //cms content blocks (its a dictionary<string,string>)
            cmsContentBlocks: { type: Object },
            cmsComposeContentBlocks: { type: Object },

            attachmentGroupId: { type: String },

            errorModel: {},

            showDeleteButton: { type: Boolean },
            showReplyButton: { type: Boolean },
            showRestoreButton: { type: Boolean },

            disableUploads: { type: Boolean, default: false }
        },
        components: {
            'replymessage-component': replyMessage,
            'success-component': successComponent
        },
        data: function () {
            return {
                mode: 'Detail', //SentConfirmation = when you respond to a message successfully
                isSavingData: false
            }
        },
        mounted: function () {
            $('#message-detail-dialog').on('hidden.bs.modal', e => {
                //after we close reset everything
                this.replyModel = {};
                this.mode = 'Detail';

                //don't reload unless they take an action. Otherwise they lose there place in the grid. So replay, delete, restore...we reload. Otherwise if they just view the message don't reload.
                //this.$emit('onReloadMessages');
            });
        },
        computed: {

            isNoReplyMessage: function () {
                if (this.detailMessageChain) {
                    return this.detailMessageChain[0].noReply;
                }

                return false;
            },

            mailboxIsNoLongerActive: function () {
                if (this.detailMessageChain) {
                    return !this.detailMessageChain[0].mbxActive;
                }

                return false;
            },

            dialogWidthCss: function () {

                let baseCss = 'modal-xs-100 modal-sm-100 modal-md-75 ';

                if (this.mode == 'SentConfirmation') {
                    baseCss += 'modal-lg-50 modal-xl-50';
                }
                else {
                    baseCss += 'modal-lg-75 modal-xl-75';
                }

                return baseCss;
            },

            //bootstrap is sticking padding on when we go xs and sm full width. So we are going to just set it to 0. hack
            isFullWidthMobile: function () {
                return this.dialogWidthCss.indexOf('modal-xs-100') > -1 || this.dialogWidthCss.indexOf('modal-sm-100') > -1;
            },

            messageToTakeActionOn: function () {
                if (!this.detailMessageChain || this.detailMessageChain.length == 0) {
                    return null;
                }

                return this.detailMessageChain[0].msgId;
            }
        },
        methods: {

            setReplyMode: function () {
                this.mode = 'Reply';
                $('#message-detail-dialog').find('.modal-body').animate({ scrollTop: 0 });
            },

            buildAttachmentDownload: function (messageObject, attachmentObject) {

                //is it available?
                if (messageObject.attachmentExpired) {
                    return null;
                }
       
                let encodedFileName = encodeURIComponent(attachmentObject.name);

                return `/api/Message/GetAttachment?attachmentId=${attachmentObject.attachmentId}&fileName=${encodedFileName}`;
            },

            deleteMessage: function () {
                this.isSavingData = true;

                MessageHttpSvc.DeleteMessage(this.messageToTakeActionOn)
                    .done(response => {
                        this.$emit('onReloadMessages');
                        //this.$emit('setNavigation', 'Inbox', 'Listing', null);
                        this.isSavingData = false;
                        $('#message-detail-dialog').modal('hide');
                    });
            },

            restoreMessage: function () {
                this.isSavingData = true;

                MessageHttpSvc.RestoreMessage(this.messageToTakeActionOn)
                    .done(response => {
                        this.$emit('onReloadMessages');
                        //this.$emit('setNavigation', 'Inbox', 'Listing', null);
                        this.isSavingData = false;
                        $('#message-detail-dialog').modal('hide');
                    });
            },

            onMessageSent: function (model) {
                this.mode = 'SentConfirmation';
                this.$emit('onReloadMessages');
                //this.$emit('setNavigation', 'Inbox', 'Listing', null);
                $('#send-message-confirmation').modal('show');
            }
        }
    };

</script>

